import { CompoundingCalculator } from '@/components/CompoundingCalculator';
import { validateForm } from '@/helpers/form-validation';
import NiceSelect from 'nice-select2/dist/js/nice-select2';

new NiceSelect(document.querySelector('.js-compound-calc-period'), {
  placeholder: 'Period',
});
new NiceSelect(document.querySelector('.js-compound-calc-currency'), {
  placeholder: 'Account currency',
});

// Init class on page load
const compoundingCalculator = new CompoundingCalculator();

document
  .querySelector('.js-compounding-calc-form')
  .addEventListener('submit', (e) => {
    e.preventDefault();
    const valid = validateForm(e.target);
    if (valid) {
      // Call the same class instance on form submit, enables recalculation and modify existing charts
      compoundingCalculator.calculateResults();
    }
  });

const symbolSelector = document.querySelector('.js-compound-calc-currency');
symbolSelector.addEventListener('change', (ev) => {
  const currencySymbols = {
    USD: '$', // US Dollar
    GBP: '£', // British Pound Sterling
    CAD: '$', // Canadian Dollar
    AUD: '$', // Australian Dollar
    JPY: '¥', // Japanese Yen
    EUR: '€', // Euro
    NZD: '$', // New Zealand Dollar
    CHF: 'CHF', // Swiss Franc
  };
  const symbol = document.querySelector('.js-currency-symbol');
  const starting = document.getElementsByName('starting')[0];
  if (ev.currentTarget.value === 'CHF') {
    starting.style.paddingLeft = '45px';
  } else {
    starting.style.paddingLeft = '20px';
  }
  symbol.innerText = currencySymbols[ev.currentTarget.value];
});

const tabBtns = document.querySelectorAll('.js-btn-tabs');
const tabTargets = document.querySelectorAll('.js-tab-panel');

tabBtns.forEach((element) => {
  element.addEventListener('click', (e) => {
    tabBtns.forEach((tab) => {
      tab.classList.remove('active');
    });
    e.target.classList.add('active');
    tabTargets.forEach((tab) => {
      tab.classList.remove('active');
      if (tab.id === e.target.dataset.target) {
        tab.classList.add('active');
      }
    });
  });
});
